import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useWorkspace } from '../../context/WorkspaceContext';
import { toast } from 'sonner';

const AdminRoute = () => {
  const { userRole, loading } = useWorkspace();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Small delay to ensure workspace context has finished its initial cascade
    if (!loading) {
      setIsReady(true);
    }
  }, [loading]);

  if (loading || !isReady || userRole === undefined) {
    return <div className="flex items-center justify-center h-screen bg-charcoal-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-charcoal-900"></div>
    </div>;
  }

  if (userRole !== 'super_admin') {
    toast.error('Unauthorized access');
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
